import React from "react";
import "./StudyNumberBadge.scss";

const StudyNumberBadge = ({
  number,
  color,
  className = "",
  title,
}) => {
  const label = String(number ?? "").trim() || "—";
  if (label === "—") return null;

  return (
    <span
      className={`study-number-badge ${className}`.trim()}
      style={color ? { backgroundColor: color } : undefined}
      title={title || label}
    >
      {label}
    </span>
  );
};

export default StudyNumberBadge;
